// Header row 1 project switcher. Mirrors TeamSwitcher but scoped to one team.

import { useNavigate } from 'react-router-dom'
import { useProject, useProjects } from '../../lib/data-hooks.js'
import { AttentionPip } from './AttentionPip.jsx'
import { useDropdown } from './useDropdown.js'

export function ProjectSwitcher({ teamId, projectId, attentionCount = 0 }) {
  const navigate = useNavigate()
  const { open, setOpen, ref } = useDropdown()
  const { data: projects } = useProjects(teamId)
  const { data: currentProject } = useProject(teamId, projectId)

  if (!teamId) return null

  const label = currentProject?.name ?? (projectId ? projectId : 'Select a project')

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className={`flex h-8 items-center gap-2 rounded-md px-2 text-sm hover:bg-[var(--color-sandstone)] ${
          projectId ? 'text-[var(--color-basalt)]' : 'text-[var(--color-schist)]'
        }`}
      >
        <span className={projectId ? 'font-medium' : ''}>{label}</span>
        <AttentionPip count={attentionCount} />
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
          <path
            d="M2 3.5l3 3 3-3"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <div
          role="menu"
          className="absolute left-0 top-9 z-40 min-w-[220px] rounded-md border border-[var(--color-sandstone)] bg-[var(--color-limestone)] py-1 shadow-lg"
        >
          {projects.length === 0 && (
            <div className="px-3 py-2 text-xs text-[var(--color-schist)]">No projects yet.</div>
          )}
          {projects.map((p) => (
            <button
              key={p.id}
              type="button"
              role="menuitem"
              onClick={() => {
                setOpen(false)
                navigate(`/teams/${teamId}/projects/${p.id}`)
              }}
              className={`block w-full px-3 py-2 text-left text-sm hover:bg-[var(--color-sandstone)] ${
                p.id === projectId
                  ? 'font-medium text-[var(--color-basalt)]'
                  : 'text-[var(--color-slate)]'
              }`}
            >
              {p.name ?? p.id}
            </button>
          ))}
          <div className="my-1 border-t border-[var(--color-sandstone)]" />
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setOpen(false)
              navigate(`/teams/${teamId}?create=1`)
            }}
            className="block w-full px-3 py-2 text-left text-sm text-[var(--color-terracotta)] hover:bg-[var(--color-sandstone)]"
          >
            Create new project
          </button>
        </div>
      )}
    </div>
  )
}
